<div class="container"><coffee-selfies-wall v-if="showWall"></coffee-selfies-wall><coffee-selfies-get-started v-else></coffee-selfies-get-started></div>